import { useEffect, useState } from "react";

import { useAppIsReady } from "Flocknote/stateHooks";

import { useGroupsWereAutoOpened } from "NavBar/navBarStore";
import { useEffectiveIsExpanded, useIsFullScreen } from "NavBar/stateHooks";

const useShowGroupsHint = () => {
  const groupsWereAutoOpened = useGroupsWereAutoOpened();
  const isFullScreen = useIsFullScreen();
  const [isExpanded] = useEffectiveIsExpanded();
  const isAppReady = useAppIsReady();
  const [delayPassed, setDelayPassed] = useState(false);

  useEffect(() => {
    if (!isAppReady) return;
    const timer = setTimeout(() => setDelayPassed(true), 2000);
    return () => clearTimeout(timer);
  }, [isAppReady]);

  return delayPassed && groupsWereAutoOpened && isFullScreen && !isExpanded;
};

export default useShowGroupsHint;
